import { useContext } from 'react';
import { ShieldAlert } from 'lucide-react';
import { Button } from '../ui/button';
import { AuthContext } from '../../contexts/AuthContext';

const Suspended = () => {
  const { moderationStatus, logout } = useContext(AuthContext);

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-screen-md flex-col items-center justify-center px-6 py-24 text-center">
      <ShieldAlert className="mb-6 h-12 w-12 text-destructive" />
      <h1 className="font-display text-3xl font-semibold">Account suspended</h1>
      <p className="mt-3 max-w-prose text-sm text-muted-foreground">
        Your account has been suspended by a moderator. While suspended, you can't access the site.
        If you believe this is a mistake, please contact us.
      </p>
      {moderationStatus?.reason && (
        <div className="mt-6 w-full max-w-sm rounded-md border border-border/60 bg-background/40 p-4 text-left">
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
            Reason
          </div>
          <p className="mt-1 text-sm">{moderationStatus.reason}</p>
        </div>
      )}
      <div className="mt-8 flex gap-2">
        <Button variant="outline" onClick={() => logout()}>
          Log out
        </Button>
      </div>
    </div>
  );
};

export default Suspended;
